export default __webpack_public_path__ + "static/media/screen2.93cb1039.png";